import { Typography } from "@mui/material";
import { useEffect } from "react";
import RefreshButton from "src/components/buttons/RefreshButton";

import { pvmStringLong, viikonpvLong } from "src/components/js/statics1";
import { useGridData } from "src/context/GridContext/GridContext";
import GridDateSelector from "src/pages/Grid/SettingsBar/components/GridDateSelector";

const styles = {
  dateSelector: {
    display: "flex",
    gap: 4,
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2px",
    flexWrap: "wrap",
  },
};

export default function Report_DateSelector() {
  const { time, setTime, reloadKeikat } = useGridData();

  useEffect(() => {
    document.title = "Raport " + pvmStringLong(time?.starttime);
  }, [time?.starttime]);

  return (
    <div style={styles.dateSelector}>
      <RefreshButton
        onClick={reloadKeikat}
        buttonProps={{
          variant: "outlined",
          sx: { height: 55 },
        }}
        tooltipProps={{ title: "Päivitä", placement: "top" }}
      />
      <Typography variant="h6" className="fixPrint">
        {viikonpvLong(time.starttime)} {pvmStringLong(time.starttime)}
      </Typography>
      <div className="noPrint">
        <GridDateSelector time={time} setTime={setTime} />
      </div>
    </div>
  );
}
